<template>
  <main role="main" class="container">
    <slot />
  </main>
</template>

<script>
export default {
  name: "OutlookLayout"
}
</script>
